import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "When we listen to a sound source in an environment, we are able to derive properties of the sound source and the environment, even if we do not see the environment. In this section, various auralizations are created in order to demonstrate different effects of space and sound source perception.",
  theory: theory,
  layout: {
    type: "custom022700",
    options: {
      data: {
        singleReflection: {
          sounds: {
            "1": `${config.ASSETS_URL}/02/27/principle/slide_1-1ms.mp3`,
            "2": `${config.ASSETS_URL}/02/27/principle/slide_1-2ms.mp3`,
            "5": `${config.ASSETS_URL}/02/27/principle/slide_1-5ms.mp3`,
            "10": `${config.ASSETS_URL}/02/27/principle/slide_1-10ms.mp3`,
            "20": `${config.ASSETS_URL}/02/27/principle/slide_1-20ms.mp3`,
            "50": `${config.ASSETS_URL}/02/27/principle/slide_1-50ms.mp3`,
            "100": `${config.ASSETS_URL}/02/27/principle/slide_1-100ms.mp3`,
            "200": `${config.ASSETS_URL}/02/27/principle/slide_1-200ms.mp3`,
            "500": `${config.ASSETS_URL}/02/27/principle/slide_1-500ms.mp3`,
            "1000": `${config.ASSETS_URL}/02/27/principle/slide_1-1000ms.mp3`,
          },
        },
        roomImpulseResponse: {
          sounds: {
            "001": `${config.ASSETS_URL}/02/27/principle/slide_2-RT.mp3`,
            "000": `${config.ASSETS_URL}/02/27/principle/slide_2.mp3`,
            "010": `${config.ASSETS_URL}/02/27/principle/slide_2-IS.mp3`,
            "011": `${config.ASSETS_URL}/02/27/principle/slide_2-IS_RT.mp3`,
            "101": `${config.ASSETS_URL}/02/27/principle/slide_2-DS_RT.mp3`,
            "100": `${config.ASSETS_URL}/02/27/principle/slide_2-DS.mp3`,
            "110": `${config.ASSETS_URL}/02/27/principle/slide_2-DS_IS.mp3`,
            "111": `${config.ASSETS_URL}/02/27/principle/slide_2-DS_IS_RT.mp3`,
          },
        },
        roomVolumePerception: {
          sounds: {
            "200m3": `${config.ASSETS_URL}/02/27/principle/slide_3-200.mp3`,
            "600m3": `${config.ASSETS_URL}/02/27/principle/slide_3-600.mp3`,
            "2000m3": `${config.ASSETS_URL}/02/27/principle/slide_3-2000.mp3`,
            "6000m3": `${config.ASSETS_URL}/02/27/principle/slide_3-6000.mp3`,
            "20000m3": `${config.ASSETS_URL}/02/27/principle/slide_3-20000.mp3`,
          },
        },
        distancePerception: {
          sounds: {
            "3m": `${config.ASSETS_URL}/02/27/principle/slide_4-3m.mp3`,
            "6m": `${config.ASSETS_URL}/02/27/principle/slide_4-6m.mp3`,
            "9m": `${config.ASSETS_URL}/02/27/principle/slide_4-9m.mp3`,
            "12m": `${config.ASSETS_URL}/02/27/principle/slide_4-12m.mp3`,
            "15m": `${config.ASSETS_URL}/02/27/principle/slide_4-15m.mp3`,
          },
        },
        soundSourceLocalization: {
          sounds: {
            inner: [
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_1.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_2.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_3.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_4.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_5.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_6.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_7.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-inner_8.mp3`,
            ],
            outer: [
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_1.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_2.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_3.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_4.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_5.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_6.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_7.mp3`,
              `${config.ASSETS_URL}/02/27/principle/slide_5-outer_8.mp3`,
            ],
          },
        },
      },
    },
  },
};

export default principle;
